import { NgIf, NgStyle } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FuseCardComponent } from '@fuse/components/card';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-card-panel',
  template: `
    <fuse-card
        class="flex flex-col px-8 py-6 pb-4 mb-5" #fuseCard>
        <div class="text-lg font-bold">{{props?.label}}</div>
        <div class="mt-2">
            <ng-container #fieldComponent></ng-container>
        </div>
    </fuse-card>
  `,
  standalone: true,
  imports: [FormlyModule, FuseCardComponent]
})
export class CardPanel extends FieldWrapper {


}
